// Span attribute naming guidelines:
// 1. ALWAYS use an attribute defined in this file--do not use a bare string. This helps maintain consistency.
// 2. When introducing a new attribute, use one from the semantic convention when possible.
// 3. If the attribute is not in the semantic convention, create a new `gecko`-prefixed attribute.

// OTel stable semantic convention for service version
export const ATTR_SERVICE_VERSION = 'service.version' as const

// OTel standard user attributes (Development stability - copied locally per OTel guidance)
export const ATTR_USER_ID = 'user.id' as const
export const ATTR_USER_EMAIL = 'user.email' as const

// Custom gecko-namespaced attributes
export const ATTR_GECKO_USER_IS_INTERNAL = 'gecko.user.is_internal' as const
export const ATTR_GECKO_ORGANIZATION_ID = 'gecko.organization.id' as const
export const ATTR_GECKO_SITE_ID = 'gecko.site.id' as const
export const ATTR_GECKO_ORG_OR_SITE_ID = 'gecko.org_or_site_id' as const
export const ATTR_GECKO_UNIT_ID = 'gecko.unit.id' as const
export const ATTR_GECKO_COMPONENT_ID = 'gecko.component.id' as const

// Kestrel attributes
export const ATTR_KESTREL_MODEL_ID = 'kestrel.kestrel_model_id' as const
export const ATTR_KESTREL_VM_ID = 'kestrel.vm_id' as const
export const ATTR_KESTREL_ICE_RETRY_COUNT = 'kestrel.ice_retry_count' as const
export const ATTR_KESTREL_DEV_MODE = 'kestrel.dev_mode' as const
